var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.text !== "",
          expression: "text !== ''"
        }
      ],
      class: _vm.bemBlockMod(_vm.backgroundColor ? "background-filled" : ""),
      style: {
        "background-color": _vm.backgroundColor || "",
        color: _vm.color || ""
      }
    },
    [_vm._v("\n  " + _vm._s(_vm.text) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }